export default {"src":"/evde-internet/_next/static/media/red-deal.884d984f.svg","height":32,"width":32};